import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Divider,
  Grid,
  Header,
  Input,
  Segment,
  Table,
  Dropdown
} from 'semantic-ui-react';
import { servicesAPI } from '../../_services';
import {
  getLocalStorage,
  dbUTCDatetimeToLocal,
  linkifyText
} from '../../utils';

const statusOptions = [
  { text: 'Active', value: 'ACTIVE' },
  { text: 'Closed', value: 'CLOSED' }
];

const countOptions = [
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '250', value: 250 },
  { text: '500', value: 500 },
  { text: '1000', value: 1000 }
];

export const ListAlerts = () => {
  const [events, setEvents] = useState([]);
  const [numEvents, setNumEvents] = useState(50);
  const [descriptionFilter, setDescriptionFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState(['ACTIVE']);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortLabel, setSortLabel] = useState('descending');
  const [sortedData, setSortedData] = useState([]);

  const sortTable = column => {
    setSortColumn(column);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortLabel(sortLabel === 'ascending' ? 'descending' : 'ascending');

    localStorage.setItem('adminAlertsSrtColumn', column);
    localStorage.setItem(
      'adminAlertsSrtDir',
      sortDirection === 'asc' ? 'desc' : 'asc'
    );
  };

  useEffect(() => {
    // Use user's preferred filter/sort settings otherwise defaults
    setNumEvents(parseInt(getLocalStorage('adminAlertsNumEvnts', 50)));
    setDescriptionFilter(getLocalStorage('adminAlertsFltrDesc', ''));
    setStatusFilter(JSON.parse(getLocalStorage('adminAlertsFltrStatus', '[]')));

    sortTable(getLocalStorage('adminAlertsSrtColumn', 'id'));
    const dir = getLocalStorage('adminAlertsSrtDir', 'desc');
    setSortDirection(dir);
    setSortLabel(dir === 'asc' ? 'descending' : 'ascending');
  }, []);

  useEffect(() => {
    servicesAPI
      .AdminServices('getEvents', numEvents)
      .then(events => setEvents(events));
  }, [numEvents]);

  useEffect(() => {
    if (events.length === 0) return;

    const sorted =
      sortColumn && sortDirection
        ? _.orderBy(events, sortColumn, sortDirection)
        : events;

    setSortedData(
      sorted
        .filter(
          ({ description }) =>
            !descriptionFilter ||
            description.toLowerCase().includes(descriptionFilter.toLowerCase())
        )
        .filter(
          ({ status }) => !statusFilter.length || statusFilter.includes(status)
        )
    );
  }, [events, descriptionFilter, statusFilter, sortColumn, sortDirection]);

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">Alerts</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid>
          <Grid.Column>
            <Grid.Row>
              <Header as="h4">Show no. alerts</Header>
              <Dropdown
                selection
                options={countOptions}
                onChange={(_, { value }) => {
                  setNumEvents(value);
                  localStorage.setItem('adminAlertsNumEvnts', value);
                }}
                value={numEvents}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid>
        <Grid.Row>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Input
              type="text"
              placeholder="filter description"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setDescriptionFilter('');
                  localStorage.setItem('adminAlertsFltrDesc', '');
                }
              }}
              value={descriptionFilter}
              onChange={(event, { value }) => {
                setDescriptionFilter(value);
                localStorage.setItem('adminAlertsFltrDesc', value);
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Dropdown
              placeholder="filter status"
              selection
              search
              options={statusOptions}
              multiple
              onChange={(e, { value }) => {
                setStatusFilter(value);
                localStorage.setItem(
                  'adminAlertsFltrStatus',
                  JSON.stringify(value)
                );
              }}
              value={statusFilter}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Grid>
        <Table sortable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={sortColumn === 'id' ? sortLabel : null}
                onClick={() => sortTable('id')}
                style={{ width: '120px' }}
              >
                ID
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'status' ? sortLabel : null}
                onClick={() => sortTable('status')}
                style={{ width: '120px' }}
              >
                Status
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'start_timestamp' ? sortLabel : null}
                onClick={() => sortTable('start_timestamp')}
                style={{ width: '130px' }}
              >
                First
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'latest_timestamp' ? sortLabel : null}
                onClick={() => sortTable('latest_timestamp')}
                style={{ width: '110px' }}
              >
                Latest
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'description' ? sortLabel : null}
                onClick={() => sortTable('description')}
                style={{ width: '80px' }}
              >
                Description
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedData.map((d, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>{d.id}</Table.Cell>
                <Table.Cell>{d.status}</Table.Cell>
                <Table.Cell>
                  {dbUTCDatetimeToLocal(d.start_timestamp)}
                </Table.Cell>
                <Table.Cell>
                  {dbUTCDatetimeToLocal(d.latest_timestamp)}
                </Table.Cell>
                <Table.Cell>{linkifyText(d.description)}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Grid>
    </Segment>
  );
};
